export default "__VITE_ASSET__BZEqsOGL__"